import { ThemeProvider } from '@mui/material';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import I18n from 'i18next';
import { FC } from 'react';
import './App.css';
import { AxiosInterceptor } from './common/config/AuthInterceptors';
import { theme } from './common/config/theme';
import AuthProvider from './common/contexts/AuthContext';
import { LoadingProvider } from './common/contexts/LoadingContext';
import Routes from './router/Routes';

import { enGB } from 'date-fns/locale/en-GB';
import { it } from 'date-fns/locale/it';
import { sl } from 'date-fns/locale/sl';
import { NotificationsProvider } from './common/contexts/NotificationsContext';
import { ReloadProvider } from './common/contexts/ReloadContext';
import './i18n';

const App: FC<{}> = () => {
  const locale = I18n.languages[0];

  return <ThemeProvider theme={theme}>
    <AuthProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={
        locale === "it-IT" ? it : locale === "sl-SI" ? sl : enGB
      }>
        <LoadingProvider>
          <AxiosInterceptor>
            <NotificationsProvider>
              <ReloadProvider>
                <Routes />
              </ReloadProvider>
            </NotificationsProvider>
          </AxiosInterceptor>
        </LoadingProvider>
      </LocalizationProvider>
    </AuthProvider>
  </ThemeProvider>;
}

export default App;
